import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import '../../../../../../../VisualAssets/IconV3/index.js';
import { IconV3 as IconV3Memoized } from '../../../../../../../VisualAssets/IconV3/Icon.js';

var LabelIcon = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(IconV3Memoized, _extends({
    typographySize: "body-s-strong",
    color: "base.default"
  }, props));
});
LabelIcon.displayName = 'FormField.LabelIcon';

export { LabelIcon };
//# sourceMappingURL=LabelIcon.js.map
